import { UserDto } from '../api/tunedRestApi';
import { createSlice } from '@reduxjs/toolkit';
import { userLogin } from '../api/authActions';
import { getTgUserData } from '@utils/tgUtils';

export interface UserSliceState {
  tgUserData: { initData: string };
  userData?: UserDto;
  avatar?: string;
  loading: boolean;
  success: boolean;
  error: string | undefined;
}

const initialState: UserSliceState = {
  tgUserData: {
    initData: getTgUserData()?.initData ?? '',
  },
  loading: true,
  success: false,
  error: undefined,
  avatar: undefined,
  userData: undefined,
};

const userSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    setSuccess: (state) => {
      state.success = true;
      state.error = undefined;
    },
    setUserData: (state, action) => {
      state.userData = action.payload;
    },
    setAvatar: (state, action) => {
      state.avatar = action.payload;
    },
    setResetUserInfo: (state) => {
      state.avatar = undefined;
      state.userData = undefined;
    },
  },
  extraReducers: (builder) => {
    // login user
    builder.addCase(userLogin.pending, (state) => {
      state.loading = true;
      state.success = false;
      state.error = undefined;
    });

    builder.addCase(userLogin.fulfilled, (state) => {
      state.loading = false;
      state.success = true;
    });

    builder.addCase(userLogin.rejected, (state, { payload }) => {
      state.loading = false;
      state.success = false;
      state.error = payload as string;
    });
  },
});

export const { setSuccess, setUserData, setAvatar, setResetUserInfo } = userSlice.actions;

export default userSlice.reducer;
